import React, { FC } from 'react';
import TabNavigations from '@src/components/TabNavigations';
import { Tabs } from '../enums/tabs.enum';
import { ContentHeaderProps } from './props';
import './styles.scss';

export const USER_PROFILE_TABS: Record<Tabs, { label: string; name: Tabs }> = {
  conversation: { label: 'Conversation', name: Tabs.CONVERSATION },
  profile: { label: 'Profile', name: Tabs.PROFILE },
};

export const ContentHeader: FC<ContentHeaderProps> = ({ onTabSwitch, activeTab }) => {
  return (
    <div className="chats-content-header">
      <TabNavigations
        activeTab={activeTab}
        className="chats-content-header__tabs"
        onClick={onTabSwitch}
        tabs={Object.values(USER_PROFILE_TABS)}
      />
    </div>
  );
};
